import { dateFormat } from 'design-system';

// Methods
import genderString from '../../../../../functions/genderString';

// sub components
import CardQuotation from '../CardQuotation';

const { dateFromServerString } = dateFormat;

type Props = {
  firstName: string;
  lastName: string;
  birthdate: string;
  gender: string;
};

/**
 * DriverDetailsCard displays information about the driver when the issuer(Customer) is different than driver
 */
const DriverDetailsCard = ({
  firstName,
  lastName,
  birthdate,
  gender,
}: Props): JSX.Element => {
  return (
    <CardQuotation
      title="Datos del conductor"
      subTitle={`${firstName} ${lastName}`}
      defaultDataList={[
        {
          Value: 'Fecha de nacimiento',
          Text: dateFromServerString(birthdate),
        },
        { Value: 'Género', Text: genderString(gender) },
      ]}
    />
  );
};

export default DriverDetailsCard;
